$('.m_slider').slick({
  dots: false,
  fade: true,
  speed: 1000,
  autoplaySpeed: 3000,
  arrows: false,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1, 
  infinite: true
});